/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useBooksList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const BookSelect = React.forwardRef(({ placeholder = 'Type to search a book', ...props }, ref) => (
  <SearchableEntitySelect
    ref={ref}
    placeholder={placeholder}
    useList={useBooksList}
    formatLabel={({ title }) => title}
    {...props}
  />
));

export default BookSelect;
